// extracted by mini-css-extract-plugin
export default {"main":"jJri","detailed-info":"v9ES","detailed-info-details":"bYfc","content":"nBbk","footer":"_o8P","footer-text":"JZ2g"};